import { render, staticRenderFns } from "./NumbersTracker.vue?vue&type=template&id=f121c99a&"
import script from "./NumbersTracker.vue?vue&type=script&lang=js&"
export * from "./NumbersTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports